import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => {
  const { border } = theme;
  return {
    wrenchMenuGroup: () => ({
      borderBottom: border.border,
      '&:last-child': {
        borderBottom: 'none',
      },
    }),
  };
});

const MenuGroup = ({ children }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  return <section className={classes.wrenchMenuGroup}>{children}</section>;
};

MenuGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MenuGroup;
